import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import { MotionBox, hoverScale } from "@rusha/shared-theme";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const MotionTypography = motion.create(Typography);
const MotionPaper = motion.create(Paper);

const CTA: React.FC = () => {
  const theme = useTheme();

  return (
    <Box id="get-started" component="section" sx={{ py: 12 }}>
      <Container maxWidth="md">
        <MotionPaper
          elevation={6}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background:
                "url(\"data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h20L0 20z' fill='%23ffffff' fill-opacity='0.05'/%3E%3C/svg%3E\")",
              backgroundSize: "20px 20px",
              zIndex: 0,
            },
          }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <MotionTypography
            variant="h3"
            align="center"
            color="white"
            sx={{ mb: 2, fontWeight: 700 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Ready to Streamline Your Deployments?
          </MotionTypography>

          <MotionTypography
            variant="body1"
            align="center"
            color="white"
            sx={{
              fontSize: "1.1rem",
              mb: 4,
              opacity: 0.9,
              maxWidth: "700px",
              mx: "auto",
            }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Get started today and deploy your first template in minutes. No
            complicated setup, just powerful deployments.
          </MotionTypography>

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <MotionBox {...hoverScale.scaleLg}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                component="a"
                href="https://app.rusha.tierravivaai.net"
                startIcon={<RocketLaunchIcon />}
                sx={{
                  bgcolor: "white",
                  color: "primary.main",
                  px: 4,
                  py: 1.5,
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: "white",
                    opacity: 0.9,
                  },
                }}
              >
                Get Started Now
              </Button>
            </MotionBox>
          </Box>
        </MotionPaper>
      </Container>
    </Box>
  );
};

export default CTA;
